import UcPaymentTransactionTypeSymbol from './UcPaymentTransactionTypeSymbol.yaml?component';

export { UcPaymentTransactionTypeSymbol };
